import React, {useState} from 'react';
import {
    Burger,
    Group,
    Text,
    Box,
    Avatar,
} from '@mantine/core';

const Header = (props) => {
    const {authUser, toggleMobile, toggleDesktop, mobileOpened, desktopOpened} = props
    const last_name = localStorage.getItem('last_name');
    const first_name = localStorage.getItem('first_name');
    const photo_url = localStorage.getItem('photo_url');

    return (
        <>
            <Group h="100%" px="md">
                <Burger
                    opened={mobileOpened}
                    onClick={toggleMobile}
                    hiddenFrom="sm"
                    size="sm"
                />
                <Burger
                    opened={desktopOpened}
                    onClick={toggleDesktop}
                    visibleFrom="sm"
                    size="sm"
                />
                <Group h="100%" px="md">
                    <img src="/new_logo_eibin.png" alt="Logo" style={{ height: 40 }} />
                    {/*<Text size="xl" fw={700}>*/}
                    {/*    Eibin / PowerBI*/}
                    {/*</Text>*/}
                </Group>
                <Box style={{marginLeft: 'auto'}}>
                    {authUser && (
                        <Group spacing="sm">
                            <Avatar
                                src={photo_url ? photo_url : null}
                                alt={`${last_name} ${first_name}`}
                                name={`${last_name} ${first_name}`}
                                size={30}
                            />
                            <Text size="md" weight={500}>
                                {last_name || ""} {first_name || ""}
                            </Text>
                        </Group>
                    )}
                </Box>
            </Group>
        </>

    );
};

export default Header;